import { Http, GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  searchByLogisticProvider({ state, commit }) {
    commit('toggleLoading', true);

    const {
      filters = null,
      pagination = {},
      sorting = {},
    } = state;

    if (filters) {
      const params = {
        logistic_provider_ids: filters.logisticProviderIds.map(lp => lp.id),
        warehouse_ids: filters.warehouseIds.map(wh => wh.id),
        start_date: filters.dateRange.start,
        end_date: filters.dateRange.end,
        localized_status: filters.localizedStatus,
        sort_direction: sorting.direction,
        page_limit: pagination.limit,
        requested_page: pagination.page,
      };

      return GraphQlClient.query(`
        query(
          $logistic_provider_ids: [Int],
          $warehouse_ids: [Int],
          $start_date: String,
          $end_date: String,
          $sort_direction: String,
          $page_limit: Int,
          $requested_page: Int,
          $localized_status: Int,
        ) {
          psl(
            logistic_provider_ids: $logistic_provider_ids,
            warehouse_ids: $warehouse_ids,
            start_date: $start_date,
            end_date: $end_date,
            sort_direction: $sort_direction,
            page_limit: $page_limit,
            requested_page: $requested_page,
            localized_status: $localized_status,
          ) {
            items {
              id,
              psl_id_in_logistic_provider,
              shippers {
                id,
              }
              shipment_order {
                volumes {
                  id,
                }
              }
              logistic_provider {
                id,
                delivery_methods {
                  id,
                  name,
                }
              }
              created,
              actions {
                is_downloadable,
                is_resendable,
              }
              warehouse {
                official_name,
              }
              localized_status,
            }
            total
          }
        }`, params)
        .then(({ data = {} }) => {
          const { items = [], total = 0 } = data.psl;

          commit('setPsls', items);
          commit('setPslsCount', total);
          commit('toggleLoading', false);
        })
        .catch(() => commit('toggleLoading', false));
    }

    return Promise.resolve();
  },

  searchByOrderNumber({ state, commit }) {
    commit('toggleLoading', true);

    const {
      filters = {
        orderList: [],
      },
      pagination = {},
      sorting = {},
    } = state;

    const params = {
      search_by: 'searchByOrder',
      order_numbers: filters.orderList,
      start_date: filters.dateRange.start,
      end_date: filters.dateRange.end,
      sort_direction: sorting.direction,
      page_limit: pagination.limit,
      requested_page: pagination.page,
    };

    return GraphQlClient.query(`
      query (
        $search_by: String,
        $order_numbers: [String],
        $start_date: String,
        $end_date: String,
        $sort_direction: String,
        $page_limit: Int,
        $requested_page: Int,
      ) {
        client {
          id,
        }
        psl(
          search_by: $search_by,
          order_numbers: $order_numbers,
          start_date: $start_date,
          end_date: $end_date,
          sort_direction: $sort_direction,
          page_limit: $page_limit,
          requested_page: $requested_page,
        ) {
          items {
            created,
            enabled,
            logistic_provider {
              id,
              name,
              delivery_method {
                id,
                name,
              }
            }
            shipment_order {
              state
              order_number,
              volumes {
                id,
              }
            }
          }
          total
        }
      }`, params)
      .then((result) => {
        const { data = {} } = result;
        const { items = [], total = 0 } = data.psl;

        commit('setPsls', items || []);
        commit('setPslsCount', total);
        commit('toggleLoading', false);
      })
      .catch(() => commit('toggleLoading', false));
  },

  searchByPslIntelipost({ state, commit }) {
    commit('toggleLoading', true);

    const {
      filters = {
        intelipostId: null,
      },
      pagination = {},
      sorting = {},
    } = state;

    if (filters) {
      const params = {
        search_by: 'searchByPslIntelipost',
        pre_shipment_list_id: filters.intelipostId,
        start_date: filters.dateRange.start,
        end_date: filters.dateRange.end,
        sort_direction: sorting.direction,
        page_limit: pagination.limit,
        requested_page: pagination.page,
      };

      return GraphQlClient.query(`
        query(
          $pre_shipment_list_id: String,
          $search_by: String,
          $start_date: String,
          $end_date: String,
          $sort_direction: String,
          $page_limit: Int,
          $requested_page: Int,
        ) {
          psl(
            pre_shipment_list_id: $pre_shipment_list_id,
            search_by: $search_by,
            start_date: $start_date,
            end_date: $end_date,
            sort_direction: $sort_direction,
            page_limit: $page_limit,
            requested_page: $requested_page,
          ) {
            items {
              id,
              psl_id_in_logistic_provider,
              shippers {
                id,
              }
              shipment_order {
                volumes {
                  id,
                }
              }
              logistic_provider {
                id,
                delivery_methods {
                  id,
                  name,
                }
              }
              created,
              actions {
                is_downloadable,
                is_resendable,
              }
              warehouse {
                official_name,
              }
              localized_status,
            }
            total
          }
        }`, params)
        .then(({ data = {} }) => {
          const { items = [], total = 0 } = data.psl;

          commit('setPsls', items);
          commit('setPslsCount', total);
          commit('toggleLoading', false);
        })
        .catch(() => commit('toggleLoading', false));
    }

    return Promise.resolve();
  },

  searchByPslShipper({ state, commit }) {
    commit('toggleLoading', true);

    const {
      filters = {
        shipperId: null,
      },
      pagination = {},
      sorting = {},
    } = state;

    if (filters) {
      const params = {
        search_by: 'searchByPslShipper',
        shipper_id: filters.shipperId,
        sort_direction: sorting.direction,
        page_limit: pagination.limit,
        requested_page: pagination.page,
      };

      return GraphQlClient.query(`
        query(
          $shipper_id: String,
          $search_by: String,
          $sort_direction: String,
          $page_limit: Int,
          $requested_page: Int,
        ) {
          psl(
            shipper_id: $shipper_id,
            search_by: $search_by,
            sort_direction: $sort_direction,
            page_limit: $page_limit,
            requested_page: $requested_page,
          ) {
            items {
              id,
              psl_id_in_logistic_provider,
              shippers {
                id,
              }
              shipment_order {
                volumes {
                  id,
                }
              }
              logistic_provider {
                id,
                delivery_methods {
                  id,
                  name,
                }
              }
              created,
              actions {
                is_downloadable,
                is_resendable,
              }
              warehouse {
                official_name,
              }
              localized_status,
            }
            total
          }
        }`, params)
        .then(({ data = {} }) => {
          const { items = [], total = 0 } = data.psl;

          commit('setPsls', items);
          commit('setPslsCount', total);
          commit('toggleLoading', false);
        })
        .catch(() => commit('toggleLoading', false));
    }

    return Promise.resolve();
  },

  searchByPslLogisticProvider({ state, commit }) {
    commit('toggleLoading', true);

    const {
      filters = {
        logisticProviderPslId: [],
      },
      pagination = {},
      sorting = {},
    } = state;

    if (filters) {
      const params = {
        search_by: 'searchByPslLogisticProvider',
        psl_logistic_provider_id: filters.logisticProviderPslId,
        start_date: filters.dateRange.start,
        end_date: filters.dateRange.end,
        sort_direction: sorting.direction,
        page_limit: pagination.limit,
        requested_page: pagination.page,
      };

      return GraphQlClient.query(`
        query (
          $search_by: String,
          $psl_logistic_provider_id: ID,
          $start_date: String,
          $end_date: String,
          $sort_direction: String,
          $page_limit: Int,
          $requested_page: Int,
        ) {
          psl(
            search_by: $search_by,
            psl_logistic_provider_id: $psl_logistic_provider_id,
            start_date: $start_date,
            end_date: $end_date,
            sort_direction: $sort_direction,
            page_limit: $page_limit,
            requested_page: $requested_page,
          ) {
            items {
              id,
              psl_id_in_logistic_provider,
              created,
              localized_status,
              shippers {
                id,
              }
              logistic_provider {
                id,
                delivery_methods {
                  id,
                  name,
                }
              }
              shipment_order {
                volumes {
                  id,
                }
              }
              warehouse {
                official_name,
              }
              actions {
                is_downloadable,
                is_resendable,
              }
            }
            total
          }
        }`, params)
          .then(({ data = {} }) => {
            const { items = [], total = 0 } = data.psl;

            commit('setPsls', items);
            commit('setPslsCount', total);
            commit('toggleLoading', false);
          })
          .catch(() => commit('toggleLoading', false));
    }

    return Promise.resolve();
  },

  generateRomaneio({ commit }, { id = null }) {
    if (id) {
      commit('toggleLoading', true);

      return Http.post('api/v1/pre_shipment_list/pdf', { pre_shipment_list_id: id })
        .then(() => commit('toggleLoading', false))
        .catch(() => commit('toggleLoading', false));
    }

    return Promise.resolve();
  },

  generateNotifis({ commit }, { id = null }) {
    if (id) {
      commit('toggleLoading', true);

      return Http.post(`api/v1/pre_shipment_list/notfis/${id}`)
        .then(() => commit('toggleLoading', false))
        .catch(() => commit('toggleLoading', false));
    }

    return Promise.resolve();
  },

  resendPsl({ commit }, { id = null }) {
    if (id) {
      commit('toggleLoading', true);

      return Http.post(`api/v1/pre_shipment_list/resend/${id}`)
        .then(() => commit('toggleLoading', false))
        .catch(() => commit('toggleLoading', false));
    }

    return Promise.resolve();
  },

  triggerPslForAllVolumes({ commit }, logisticProviderId = null) {
    commit('setSendPslLoading', true);

    const requestBody = {
      logistic_provider_id: logisticProviderId,
    };

    return Http.post('api/v1/pre_shipment_list/send/', requestBody)
      .then(() => commit('setSendPslLoading', false))
      .catch(() => commit('setSendPslLoading', false));
  },

  triggerPslForSelectedVolumes({ commit }, payload = {}) {
    commit('setSendPslLoading', true);

    return Http.post('api/v1/pre_shipment_list/resend_volumes/', payload)
      .then(() => commit('setSendPslLoading', false))
      .catch(() => commit('setSendPslLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-psl/features/list/store/actions.js